// 차량 이름과 이미지 경로 매핑 테이블
export const vehicleImageMap: Record<string, string> = {
  // 경차
  '레이': '/car/ray.png',
  '캐스퍼': '/car/casper.png',

  // 준중형 세단
  '아반떼 AD': '/car/avante-ad.png',
  '아반떼 CN7': '/car/avante-cn7.png',
  '아반떼 CN7 FL': '/car/avante-cn7-fl.png',
  '아반떼': '/car/avante-cn7-fl.png', // 기본값

  // 소형 SUV
  '베뉴': '/car/venue.png',

  // 중형 세단
  'K5': '/car/k5.png',
  '3세대 K5': '/car/k5.png',
  '소나타': '/car/sonata-dn8.png',
  '소나타 DN8': '/car/sonata-dn8.png',
  '쏘나타 디 엣지': '/car/sonata-dn8.png',

  // 대형 세단
  '그랜저': '/car/grandeur-gn7.png',
  '그랜져': '/car/grandeur-gn7.png',
  '그랜저 GN7': '/car/grandeur-gn7.png',
  '그랜져 GN7': '/car/grandeur-gn7.png',
  '제네시스 G80': '/car/genesis-g80.png',
  'G80': '/car/genesis-g80.png',

  // 준중형 SUV
  '투싼': '/car/tucson.png',
  '셀토스': '/car/seltos.png',
  '토레스': '/car/torres.png',

  // 중형 SUV
  '싼타페': '/car/santafe.png',
  '팰리세이드': '/car/palisade.png',
  '디 올뉴 펠리세이드': '/car/palisade.png',
  '스포티지': '/car/sportage.png',
  '쏘렌토': '/car/sorento-fl.png',
  '4세대 쏘렌토 FL': '/car/sorento-fl.png',
  '소렌토MQ4 FL': '/car/sorento-fl.png',

  // 미니밴/승합
  '카니발': '/car/carnival-9-v2.png', // 기본값
  '4세대 카니발': '/car/carnival-9-v2.png',
  '4세대카니발': '/car/carnival-9-v2.png',
  '카니발 리무진 7인승': '/car/carnival-limousine-7.png',
  '카니발 리무진 4세대 7인승': '/car/carnival-limousine-7.png',
  '4세대 카니발 리무진': '/car/carnival-limousine-7.png',
  '4세대카니발 리무진': '/car/carnival-limousine-7.png',
  '4세대카니발리무진': '/car/carnival-limousine-7.png',
  '카니발 9인승': '/car/carnival-9-v2.png',
  'All New 카니발 9인승': '/car/carnival-9-v1.png',
  'All New 카니발 4세대 9인승': '/car/carnival-9-v2.png',
  '카니발 리무진': '/car/carnival-limousine.png',
  'All New 카니발 리무진': '/car/carnival-limousine.png',
  '그랜드스타렉스': '/car/grand-starex.png',
  '스타리아': '/car/staria-9.png', // 기본값
  '스타리아 9인승': '/car/staria-9.png',
  '스타리아 11인승': '/car/staria-11.png',
  '쏠라티': '/car/solati.png',

  // 전기차
  'Model Y': '/car/model-y.png',
  '테슬라 Model Y': '/car/model-y.png',
  '볼트 EV': '/car/bolt-ev.png',
  '볼트(EV)': '/car/bolt-ev.png',
};

// 차량 이름으로 이미지 경로를 찾는 함수
export const getVehicleImage = (modelName: string): string => {
  // 정확한 매칭 시도
  if (vehicleImageMap[modelName]) {
    return vehicleImageMap[modelName];
  }

  // 부분 매칭 시도 (예: "아반떼 CN7 하이브리드" -> "아반떼 CN7")
  for (const [key, value] of Object.entries(vehicleImageMap)) {
    if (modelName.includes(key) || key.includes(modelName)) {
      return value;
    }
  }

  // 기본 이미지 (매칭되는 이미지가 없을 경우)
  return '/car/placeholder.png';
};
